import { render } from "./footer.vue?vue&type=template&id=81a6a884&scoped=true"
import script from "./footer.vue?vue&type=script&lang=js"
export * from "./footer.vue?vue&type=script&lang=js"

import "./footer.vue?vue&type=style&index=0&id=81a6a884&scoped=true&lang=scss"

import exportComponent from "D:\\Project\\DeepLink\\DeepLinkWebsite\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-81a6a884"]])

export default __exports__